import React, { useState, useEffect } from "react";
import agLogo from "./sales/ag-logo.png";
import { useNavigate } from "react-router-dom";

import { AUTH_API_BASE } from "./config/api";
export default function Login({ onLogin }) {
  const API_BASE = AUTH_API_BASE;
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState("");
  // Reset on mount
  useEffect(() => {
    setUsername("");
    setPassword("");
    //setError("");
  }, []);
const [isLoading, setIsLoading] = useState(false);

 const normalizeAccess = (access) => {
  if (Array.isArray(access)) {
    return access.map((item) => String(item).toLowerCase().replace(/\s+/g, "")).filter(Boolean);
  }

  if (access && typeof access === "object") {
    return Object.keys(access)    
      .filter((key) => access[key])
      .map((key) => key.toLowerCase().replace(/\s+/g, ""))
      .filter(Boolean);
  }

  if (typeof access === "string") {
    try {
      const parsed = JSON.parse(access);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item).toLowerCase().replace(/\s+/g, "")).filter(Boolean);
      }
    } catch {
      return access
        .split(",")
        .map((item) => item.toLowerCase().replace(/\s+/g, ""))
        .filter(Boolean);
    }
  }

  return [];
 };

 const handleLogin = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError("");

  try {
    // ✅ Normal login using backend API
    const res = await fetch(`${API_BASE}/login`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    const data = await res.json();

    if (!res.ok || !data?.user?.username) {
      setError(data.error || "Invalid username or password");
      return;
    }

    // Only remove old auth info, keep saved filters intact
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("username");
    localStorage.removeItem("userRole");
    localStorage.removeItem("permissions");
    localStorage.removeItem("access");
    localStorage.removeItem("loggedUser");
    localStorage.removeItem("currentUser");

let accessList = normalizeAccess(data?.user?.access);

    try {
      const roleRes = await fetch(`${API_BASE}/rolemaster`);
      if (roleRes.ok) {
        const roleData = await roleRes.json();
        const matchedUser = Array.isArray(roleData)
          ? roleData.find(
              (user) =>
                String(user?.username || "").toLowerCase().trim() ===
                String(data?.user?.username || "").toLowerCase().trim()
            )
          : null;

        const dbAccess = normalizeAccess(matchedUser?.access);
        if (dbAccess.length > 0) {
          accessList = dbAccess;
        }
      }
    } catch (accessErr) {
      console.error("Role access refresh failed:", accessErr);
    }

localStorage.setItem("isAuthenticated", "true");
localStorage.setItem("username", data.user.username);
localStorage.setItem("userRole", data.user.role);
if (data.user.permissions) localStorage.setItem("permissions", JSON.stringify(data.user.permissions));
localStorage.setItem("access", JSON.stringify(accessList));
localStorage.setItem("loggedUser", JSON.stringify(data.user));
localStorage.setItem(
  "currentUser",
  JSON.stringify({ ...data.user, access: accessList })
);

onLogin({ ...data.user, access: accessList });

navigate("/dashboard");
  } catch (err) {
    console.error("Login error:", err);
    setError("Unable to connect to server. Please try again later.");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <main className="portal-login">
      <section className="portal-login-story" aria-label="Ali Gholami Reports">
        <div className="portal-login-brand"><img src={agLogo} alt="Ali Gholami" /><span>AG REPORTS</span></div>
        <div className="portal-login-story-content"><span className="portal-welcome-kicker">YOUR BUSINESS. IN FOCUS.</span><h1>Every detail.<br />A clearer picture.</h1><p>One workspace for your reports, your operations, and the decisions that move your business forward.</p><div className="portal-login-topics"><span>Sales insights</span><span>Purchasing</span><span>Operations</span></div></div>
        <div className="portal-login-art" aria-hidden="true"><div className="portal-orbit orbit-one" /><div className="portal-orbit orbit-two" /><div className="portal-orbit orbit-three" /></div>
        <small className="portal-login-story-footer">ALI GHOLAMI TRADING</small>
      </section>
      <section className="portal-login-form-side">
        <div className="portal-login-mobile-brand"><img src={agLogo} alt="Ali Gholami" /><strong>AG Reports</strong></div>
        <div className="portal-login-form-wrap"><span className="portal-eyebrow">WELCOME BACK</span><h2>Sign in to your workspace</h2><p>Enter your account details to continue.</p>
          <form onSubmit={handleLogin} className="portal-login-form">
            <label htmlFor="portal-username">Username or email</label><input id="portal-username" name="username" type="text" autoComplete="username" placeholder="Enter your username" value={username} onChange={(event) => setUsername(event.target.value)} required />
            <label htmlFor="portal-password">Password</label><div className="portal-password-field"><input id="portal-password" name="password" type={passwordVisible ? "text" : "password"} autoComplete="current-password" placeholder="Enter your password" value={password} onChange={(event) => setPassword(event.target.value)} required /><button type="button" onClick={() => setPasswordVisible((visible) => !visible)} aria-label={passwordVisible ? "Hide password" : "Show password"}>{passwordVisible ? "Hide" : "Show"}</button></div>
            {error && <div role="alert" className="portal-login-error">{error}</div>}
            <button type="submit" className="portal-login-submit" disabled={isLoading}>{isLoading ? "Signing in…" : "Sign in"}<span aria-hidden="true">→</span></button>
          </form>
          <div className="portal-login-help">Need access? Contact your portal administrator.</div>
        </div>
        <footer className="portal-login-footer">Ali Gholami Reports <span>Business workspace</span></footer>
      </section>
    </main>
  );
}
